const rotas = [
  {
    path: "/:obra/field/checklist",
    name: "Checklist Field",
    component: () => import("./ConfigurarChecklist.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Automação | Checklist",
      title: "Configurar Checklist OS",
      icon: "mdi-playlist-edit",
      subject: ["FIELD"],
      action: ["config"],
      showMenu: true,
      grupo: "field",
      grupoTitle: "Field Services",
    },
  },
  {
    path: "/:obra/field/config",
    name: "Configurar EAP Field",
    component: () => import("./ConfigurarEap.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Lista de OS |",
      title: "Definir EAP",
      icon: "mdi-notebook-edit-outline",
      subject: ["FIELD"],
      action: ["config"],
      showMenu: true,
      grupo: "field",
      grupoTitle: "Field Services",
    },
  },
  {
    path: "/:obra/field/ordensServico",
    name: "Lista de OS Field Services",
    component: () => import("./ListarOS.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Automacao",
      title: "Ordens de serviço Field Services",
      icon: "mdi-list-status",
      subject: ["FIELD"],
      action: ["read"],
      showMenu: true,
      grupo: "field",
      grupoTitle: "Field Services",
    },
  },
  //====================
  {
    path: "/:obra/automacao/checklist",
    name: "Checklist Automação",
    component: () => import("./ConfigurarChecklist.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Automação | Checklist",
      title: "Configurar Checklist OS",
      icon: "mdi-playlist-edit",
      subject: ["AUTOMACAO"],
      action: ["config"],
      showMenu: true,
      grupo: "automacao",
      grupoTitle: "Automação",
    },
  },
  {
    path: "/:obra/automacao/config",
    name: "Configurar EAP OS",
    component: () => import("./ConfigurarEap.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Lista de OS |",
      title: "Definir EAP",
      icon: "mdi-notebook-edit-outline",
      subject: ["AUTOMACAO"],
      action: ["config"],
      showMenu: true,
      grupo: "automacao",
      grupoTitle: "Automação",
    },
  },
  {
    path: "/:obra/automacao/ordensServico",
    name: "Lista de OS Automacao",
    component: () => import("./ListarOS.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Automacao",
      title: "Ordens de serviço automação",
      icon: "mdi-list-status",
      subject: ["AUTOMACAO"],
      action: ["read"],

      showMenu: true,
      grupo: "automacao",
      grupoTitle: "Ordens de serviço",
    },
  },

  //====================
  {
    path: "/:obra/checklist/:tipo/preencher",
    name: "Preencher Checklist",
    component: () => import("./PreencherChecklist.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Preencher Checklist",
      title: "Preencher Checklist OS",
      icon: "mdi-text-box-multiple-outline",
      subject: ["AUTOMACAO", "FIELD"],
      action: ["create"],

      showMenu: false,
    },
  },
  {
    path: "/:obra/ordensServico",
    name: "Lista de OS",
    component: () => import("./ListarOS.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Lista de OS",
      title: "Ordens de serviço",
      icon: "mdi-text-box-multiple-outline",
      subject: ["AUTOMACAO", "FIELD"],
      action: ["read"],

      showMenu: true,
      grupo: "RDO",
      grupoTitle: "RDO",
    },
  },
  {
    path: "/:obra/ordensServico/:tipo/:idOs",
    name: "Dados OS",
    component: () => import("./DadosOs.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Lista de OS",
      title: "Dados da OS",
      icon: "mdi-text-box-multiple-outline",
      subject: ["AUTOMACAO", "FIELD"],
      action: ["read"],

      showMenu: false,
      grupo: "RDO",
      grupoTitle: "RDO",
    },
  },
  {
    path: "/:obra/ordensServico/:tipo/:idOs/diario/:idDiario",
    name: "ver diario",
    component: () => import("./DiarioOs.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Lista de OS | Dados OS ",
      title: "Visualizar diário",
      icon: "mdi-text-box-multiple-outline",
      subject: ["AUTOMACAO", "FIELD", "RDO"],
      action: ["read"],
      showMenu: false,
      grupo: "RDO",
      grupoTitle: "RDO",
    },
  },

  {
    path: "/:obra/ordensServico/:tipo/:idOs/diario",
    name: "Diario OS",
    component: () => import("./NovoDiario.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Lista de OS",
      title: "Novo diário OS",
      icon: "mdi-text-box-multiple-outline",
      subject: ["AUTOMACAO", "FIELD"],
      action: ["create"],
      showMenu: false,
      grupo: "automacao",
      grupoTitle: "Diarios",
    },
  },
  {
    path: "/:obra/ordensServico/:tipo/:idOs/diario/:idDiario/editar",
    name: "Editar Diario OS",
    component: () => import("./NovoDiario.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Lista de OS | Dados OS",
      title: "Editar diário OS",
      icon: "mdi-text-box-multiple-outline",
      subject: ["AUTOMACAO", "FIELD", "RDO", "POSVENDAS"],
      action: ["update"],
      showMenu: false,
      grupo: "automacao",
      grupoTitle: "Diarios",
    },
  },
];

export default rotas;
